module.exports = __webpack_public_path__ + "img/right.e78703b9.svg";